import { noPayload, payload } from '@angular-architects/ngrx-toolkit';
import { APP_DEFAULTS } from '@app/constants/app-defaults';
export const appActions = {
    private: {
        restAll: payload<{
            isBusy: boolean;
            titlePage: string;
            languageSelected: string;
            i18n: typeof APP_DEFAULTS.i18n;
            tkn: string | null;
        }>(),
    },
    public: {
        init: noPayload,
        initializeTranslations: payload<{ lang: string }>(),
        setIsBusy: payload<{
            value: boolean;
        }>(),
        setTitlePage: payload<{
            value: string;
        }>(),
        setLanguageSelected: payload<{
            value: string;
        }>(),
        setTranslations: payload<{ value: typeof APP_DEFAULTS.i18n }>(),
        setToken: payload<{ value: string | null }>(),
        setIsVendorUser: payload<{ value: boolean }>(),
        reset: noPayload,
        setLocationHistory: payload<{
            value: {
                prevUrl: string;
                currentUrl: string;
            };
        }>(),
        setPrevInspectionPage: payload<{
            value: string;
        }>(),
    },
};

export type AppActions = typeof appActions;
